import React, { Component } from 'react';
import { Form } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { isEmpty, map } from 'lodash';

import { resetSearch, clearSearch } from '../../data/searchField/actions';
import SearchField from './SearchField';

class Search extends Component {
  constructor(props) {
    super(props);
    this.state = {
      vin: '',
      dealerNumbers: '',
      dealerNumber: '',
      locationInitial: '',
      auctionAccessNumber: '',
      batchId: '',
      vra: '',
      User: '',
      changed: {},
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  UNSAFE_componentWillMount() {
    const { vin } = this.props;
    if (!isEmpty(vin)) {
      this.setState({ vin });
    }
  }

  handleInputChange(event) {
    const { resetSearchFields } = this.props;
    const { target } = event;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const { name } = target;
    resetSearchFields(name);
    this.setState({
      [name]: value,
      changed: { [name]: true },
    });
  }

  render() {
    const {
      onSubmit,
      searchFields,
      clearSearchFields,
      searchOptions,
      multipleSearches,
      noPlaceholder,
    } = this.props;
    const { changed } = this.state;

    if (!isEmpty(searchFields) && !multipleSearches) {
      clearSearchFields({});
    }

    return (
      <div>
        <Form onSubmit={onSubmit}>
          <Form.Group widths='two'>
            {map(searchOptions, searchOption => (
              <SearchField
                handleInputChange={this.handleInputChange}
                searchOption={searchOption}
                searchFields={searchFields}
                value={this.state[searchOption]} // eslint-disable-line react/destructuring-assignment
                multipleSearches={multipleSearches}
                changed={changed}
                noPlaceholder={noPlaceholder}
                key={searchOption}
              />
            ))}
            <Form.Field>
              <Form.Button color='green' inverted>
                Search
              </Form.Button>
            </Form.Field>
          </Form.Group>
        </Form>
      </div>
    );
  }
}

Search.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  searchFields: PropTypes.object,
  vin: PropTypes.string,
  resetSearchFields: PropTypes.func,
  clearSearchFields: PropTypes.func,
  searchOptions: PropTypes.array,
  multipleSearches: PropTypes.bool,
  noPlaceholder: PropTypes.bool,
};

const mapDispatchToProps = dispatch => ({
  clearSearchFields: () => {
    dispatch(clearSearch());
  },
  resetSearchFields: field => {
    dispatch(resetSearch(field));
  },
});

export default compose(connect(null, mapDispatchToProps))(Search);
